import { Command } from "./command";

export class SaveTimecardDataCommand extends Command {
  constructor(
    autosaveQueueRef,
    isProcessingQueueRef,
    requestData,
    originalData,
    updateDataCacheFunc,
    saveRowMutation,
    isForPayroll
  ) {
    super();
    this.autosaveQueueRef = autosaveQueueRef;
    this.isProcessingQueueRef = isProcessingQueueRef;
    this.requestData = requestData;
    this.originalData = originalData;
    this.saveRowMutation = saveRowMutation;
    this.updateDataCacheFunc = updateDataCacheFunc;
    this.isForPayroll = isForPayroll ?? false;
  }

  async execute() {
    this.autosaveQueueRef.current.push({
      ...this.requestData,
      data: {
        ...this.requestData.data,
        isForPayroll: this.isForPayroll,
      },
    });
    this.updateDataCacheFunc(
      this.requestData.data?.applicantId,
      {
        timeIn: this.requestData.data.timeIn,
        timeOut: this.requestData.data.timeOut,
        payRate: this.requestData.data.payRate,
        billRate: this.requestData.data.billRate,
        deductionCode: this.requestData.data.deductionCode,
        deductionAmount: this.requestData.data.deductionAmount,
        deductionAmountType: this.requestData.data.deductionAmountType,
        // deductionMaxAmount: this.requestData.data.deductionMaxAmount,
        // deductionMaxAmountType: this.requestData.data.deductionMaxAmountType,
        deductionSponsor: this.requestData.data.deductionSponsor,
        salary: this.requestData.data.salary,
        earningId: this.requestData.data.earningId,
        // totalHours: this.requestData.data.totalHours,
        ...(this.requestData.data.timecardId ? { punchId: this.requestData.data.timecardId } : {}),
      },
      this.requestData.data?.partnerSlug
    );
    if (this.isProcessingQueueRef.current) return true; // Already processing queue. Do nothing
    this.isProcessingQueueRef.current = true;
    try {
      while (this.autosaveQueueRef.current.length) {
        const currentItem = this.autosaveQueueRef.current.shift();
        // eslint-disable-next-line no-continue
        if (!currentItem) continue;
        // eslint-disable-next-line no-await-in-loop
        await this.saveRowMutation.mutateAsync(currentItem);
      }
    } finally {
      this.isProcessingQueueRef.current = false;
    }
    return true;
  }

  async undo() {
    this.autosaveQueueRef.current.push({
      ...this.requestData,
      data: {
        ...this.requestData.data,
        ...this.originalData,
        isForPayroll: this.isForPayroll,
      },
    });
    this.updateDataCacheFunc(
      this.requestData.data?.applicantId,
      {
        ...this.originalData,
        ...(this.requestData.data.timecardId ? { punchId: this.requestData.data.timecardId } : {}),
      },
      this.requestData.data?.partnerSlug
    );
    if (this.isProcessingQueueRef.current) return true; // Already processing queue. Do nothing
    this.isProcessingQueueRef.current = true;
    try {
      while (this.autosaveQueueRef.current.length) {
        const currentItem = this.autosaveQueueRef.current.shift();
        // eslint-disable-next-line no-continue
        if (!currentItem) continue;
        // eslint-disable-next-line no-await-in-loop
        await this.saveRowMutation.mutateAsync(currentItem);
      }
    } finally {
      this.isProcessingQueueRef.current = false;
    }
    return true;
  }
}
